import worker from 'workerize-loader!./websocket.worker'
import priceWorker from 'workerize-loader!./priceWebsocket.worker'
import addMethods from 'workerize-loader/dist/rpc-wrapper'

// workerize-loader extracts the worker's exports at build time, but with webpack 5's
// persistent cache the extraction comes back empty on a cold `npm start`, leaving the
// wrappers without their RPC methods until the worker file is re-saved. The worker-side
// RPC handler resolves methods at runtime, so re-attaching the known methods here keeps
// the wrappers complete regardless of what the loader extracted.
const WEBSOCKET_WORKER_METHODS = ['connectWS', 'sendEvent', 'closeWS', 'getTradeBlotterAfterALotTime', 'test']
const PRICE_WORKER_METHODS = ['connectPricerWS', 'sendEvent', 'closeWS']

const ensureMethods = (instance, methods) => {
  const missing = methods.filter(method => typeof instance[method] !== 'function')
  if (missing.length) {
    addMethods(instance, missing)
  }
  return instance
}

let workerInstance = null
export const getWorker = () => {
  if (!workerInstance) {
    workerInstance = ensureMethods(worker(), WEBSOCKET_WORKER_METHODS)
  }
  return workerInstance
}

const webSocketWorkerEvent = getWorker()
const webSocketWorkerPriceEvent = ensureMethods(priceWorker(), PRICE_WORKER_METHODS)

export { webSocketWorkerEvent, webSocketWorkerPriceEvent }
